module.exports = __webpack_public_path__ + "static/media/High Power Stations.363e337d.svg";